import React, {Component} from 'react';
import classnames from 'classnames';
import axios from 'axios';
import {apiUrl} from '../../config/config';
import $ from "jquery";

import VitalsNav from '../vitals/VitalsNav';

import EventTab from './EventTab';
import BeatsTab from './BeatsTab';
import SummaryTab from './SummaryTab';
import HeartRateTab from './HeartRateTab';
import SideBarGraph from './SideBarGraph';
import DoctorFindingsTab from './DoctorFindingsTab';


class UserChart extends Component {

  constructor() {
    super();
    this.state = {
      menus : [
        {},
      ],
      profileLink : '/user-profile',
      treemenu:[],
      clickedPI:'',
      rpeaks:[],
      databaseid:'',
      reoprtLink:'#',
      reportStatus:''
    };
    this.updateState = this.updateState.bind(this);
    this.updateRpeaks = this.updateRpeaks.bind(this);
    this.regenerateReport = this.regenerateReport.bind(this);
  }

  updateState(e) {
    console.log(e.currentTarget.id);
    var clickedPI = e.currentTarget.id.toString();
    var clickedPI_ = clickedPI.substring(0, 2)+':'+clickedPI.substring(2, 4)+':'+clickedPI.substring(4, 6)
    var userid = this.props.match.params.userid;
    var databaseid = this.props.match.params.databaseid;
    if (typeof databaseid === 'undefined'){
      databaseid="0";
    }
    const data = {
      userid : userid,
      databaseid : databaseid,
      clickedPI_:clickedPI_
    };
    axios
      .post(apiUrl+'api/common/getRpeakIndex',data)
      .then(res => {
        console.log(res.data.rpeakindex);
          this.setState({
            clickedPI:res.data.rpeakindex
          })
      })
      .catch(err =>
        console.log(err)
      );
  }
  updateRpeaks(data) {
    this.setState({
      rpeaks:data
    })
  }

  regenerateReport(e) {
    const userid = this.props.match.params.userid;
    axios
        .get('https://web.mybiocalculus.com/html/welcome/regenerateReoprt/'+userid)
        .then(res => {
          console.log(res.data);
        })
        .catch(err => {
            console.log(err);
        });
  }

  componentDidMount() {
  }

  render() {
    return (
    <div className="vitals-page vitals-chart-page">
      <VitalsNav/>
    </div>
    )
  }
}

export default UserChart;
